import React from 'react';
import { parse } from 'date-fns';
import {
    isEmptyObject, formattedRevenueAmountValues, formattedSoldTicketValue, setBorder,
    checkIfAmountIsZero, checkIfNullOrUndefined, isInvalidValueExistsInRow
} from '../../common/utility/utility';
import {  Tooltip } from 'react-bootstrap';
import { LabelText } from '../../components/Language';


export const IsDisablingSubmitForFutureDateSelection = (row) => {
    if (row.isShopOpen === "Yes") {
        const revDate = parse(row.revenueDate, "dd/MM/yyyy", new Date());
        const currDate = new Date();
        return revDate && revDate > currDate;
    }

    return false;
}

export const getRemarksFilterValue = (isShopOpen, remarksOptions) => {
    return remarksOptions.filter(x => x.codeValueCategory.toLowerCase() === isShopOpen.toLowerCase())
}

export const checkIsShopOpenStatusCorrect = (row, setError, error) => {
    if (row.isShopOpen === "No" && (checkIfAmountIsZero(row.revenueAmount.tax_0) || 
                    checkIfAmountIsZero(row.revenueAmount.tax_6) || checkIfAmountIsZero(row.revenueAmount.tax_12)
                     || checkIfAmountIsZero(row.revenueAmount.tax_21) ||
        (row.soldTicket !== "0" && row.soldTicket !== 0))) {
        row.isChecked = false;
        row.isSelectionAllowed = false;
        row.isShopOpen_ErrorMessage = "shop_openstatus";
        
        setError("shop_openstatus");
        setBorder("isShopOpen", row.index, "highlight-field", true);
        return true;
    }
    else {
        row.isShopOpen_ErrorMessage = "";
        setBorder("isShopOpen", row.index, "highlight-field", false);
        
        if (error && error.trim() === "shop_openstatus") {
            setError(null);
        }

        return false;
    }
}

export const isCheckboxSelectionAllowed = (row, setError, error) => {
    let isError = false;

    if (!row.isSubmitted && row.isMonthlySubmitted) {
        if (checkIfNullOrUndefined(row.revenueAmount.tax_0)) { isError = true;}
        else if (checkIfNullOrUndefined(row.revenueAmount.tax_6)) { isError = true; }
        else if (checkIfNullOrUndefined(row.revenueAmount.tax_12)) {  isError = true; }
        else if (checkIfNullOrUndefined(row.revenueAmount.tax_21)) { isError = true; }
        else if (checkIfNullOrUndefined(row.soldTicket)) { isError = true;}
        else if (row.isShopOpen === "No") {
            isError = checkIsShopOpenStatusCorrect(row, setError,error);
        }
        else if ((row.tax_0_ErrorMessage && row.tax_0_ErrorMessage.trim() !== "") ||
            (row.tax_6_ErrorMessage && row.tax_6_ErrorMessage.trim() !== "") ||
            (row.tax_12_ErrorMessage && row.tax_12_ErrorMessage.trim() !== "") ||
            (row.tax_21_ErrorMessage && row.tax_21_ErrorMessage.trim() !== "") ||
            (row.isShopOpen_ErrorMessage && row.isShopOpen_ErrorMessage.trim() !== "") ||
            (row.remarks_ErrorMessage && row.remarks_ErrorMessage.trim() !== "")||
            (row.soldTicket_ErrorMessage && row.soldTicket_ErrorMessage.trim() !== "") 
            ) {
            isError = true;
        }
    }

    return isError;
}

export function InitialFormatRevenueData(initialData, remarksOptions, setError,  error) {
    if (initialData && initialData.length > 0) {
        initialData = initialData.map(d => {
            return {
                ...d,
                revenueAmount: formattedRevenueAmountValues(d),
                soldTicket: formattedSoldTicketValue(d),
                isShopOpen: d.isShopOpen,
                remarksOptionValues: getRemarksFilterValue(d.isShopOpen, remarksOptions),
                remarksId: d.remarksId,
                remarksCode: d.remarksCode,
                isSelectionAllowed: !isCheckboxSelectionAllowed(d, setError,  error),
                isChecked: d.isSelectionAllowed && d.isChecked ? d.isChecked : false,
                isFutureDateAndShopOpenYes: IsDisablingSubmitForFutureDateSelection(d),
                changeRequest: d.changeRequest && !isEmptyObject(d.changeRequest) ? {
                    ...d.changeRequest,
                    revenueAmount: formattedRevenueAmountValues(d.changeRequest),
                    soldTicket: formattedSoldTicketValue(d.changeRequest)
                } : null,
                crRemarksOptionValues: d.changeRequest && !isEmptyObject(d.changeRequest) ? getRemarksFilterValue(d.changeRequest.isShopOpen, remarksOptions) : null,
                tax_0_ErrorMessage: d.tax_0_ErrorMessage,
                tax_6_ErrorMessage: d.tax_6_ErrorMessage,
                tax_12_ErrorMessage: d.tax_12_ErrorMessage,
                tax_21_ErrorMessage: d.tax_21_ErrorMessage,
                soldTicket_ErrorMessage: d.soldTicket_ErrorMessage,
                isShopOpen_ErrorMessage: d.isShopOpen_ErrorMessage,
                remarks_ErrorMessage: d.remarks_ErrorMessage,
                businessPartnerRemarks_ErrorMessage: d.businessPartnerRemarks_ErrorMessage
            }
        });
    }

    return initialData;
}

export const submitTooltip = (
    <Tooltip id="submitButton">
        <LabelText tid="submit" />
    </Tooltip>
);

export const lockedSubmitTooltip = (
    <Tooltip id="lockedSubmitButton">
        <LabelText tid="submitdisabled" />
    </Tooltip>
);

export const futureDateSubmitTooltip = (
    <Tooltip id="futuredateSubmitButton" style={{ whiteSpace: "pre-wrap" }}>
        <LabelText tid="futuredateDisableSubmit" />
    </Tooltip>
);

export const checkAreInValidValuesForShopOpenYes = (row, isSubmit, isSelectAll, setError,error,
    setRevenueData,setErrorPopUpHandler ) => {
    let isError = false;
    let errMsg = ""

    if (row.isShopOpen === "Yes" && (checkIfAmountIsZero(row.revenueAmount.tax_0) || 
            checkIfAmountIsZero(row.revenueAmount.tax_6) || checkIfAmountIsZero(row.revenueAmount.tax_12) 
            || checkIfAmountIsZero(row.revenueAmount.tax_21)) &&
      (row.soldTicket === "0" || row.soldTicket === 0)) {
      isError = true;
      errMsg = "soldticketvalidation1";
    }
     else if (row.isShopOpen === "Yes" && 
     (!checkIfNullOrUndefined(row.revenueAmount.tax_0) && !checkIfNullOrUndefined(row.revenueAmount.tax_6) &&
      !checkIfNullOrUndefined(row.revenueAmount.tax_12) && !checkIfNullOrUndefined(row.revenueAmount.tax_21) &&
      !checkIfAmountIsZero(row.revenueAmount.tax_0) && !checkIfAmountIsZero(row.revenueAmount.tax_6) &&
      !checkIfAmountIsZero(row.revenueAmount.tax_12) && !checkIfAmountIsZero(row.revenueAmount.tax_21)) &&
      (row.soldTicket !== "0" && row.soldTicket !== 0)) {
      errMsg = "soldticketvalidation2";
      isError = true;
    } else if (isInvalidValueExistsInRow(row)) {

      if (row.tax_0_ErrorMessage !== "") { setError(row.tax_0_ErrorMessage);} 
      else if (row.tax_6_ErrorMessage !== "") {setError(row.tax_6_ErrorMessage);}
      else if (row.tax_12_ErrorMessage !== "") { setError(row.tax_12_ErrorMessage);}
      else if (row.tax_21_ErrorMessage !== "") {setError(row.tax_21_ErrorMessage);}
      else if (row.soldTicket_ErrorMessage !== "") {setError(row.soldTicket_ErrorMessage); }

      isError = true
    }

    if (isError && isSubmit) {
      if (error && error.trim() === "shop_openstatus") {
        setError(null);
      }

      row.isChecked = false;
      row.isSelectionAllowed = false;
      row.soldTicket_ErrorMessage = errMsg;
      
      setRevenueData(row.index, row.contractCode, row);
      if (!isSelectAll) {
        setErrorPopUpHandler(errMsg, row.isChangeRequestAllowed ? "cr_submission" : undefined);
      }

      setBorder("soldTicket", row.index, "highlight-field", true);
    } else if (isError) {
      if (error && error.trim() === "shop_openstatus") {
        setError(null);
      }

      row.isSelectionAllowed = false;
      row.isChecked = false;
      
      setRevenueData(row.index, row.contractCode, row);
    } else if (!isSubmit) {
      row.soldTicket_ErrorMessage = "";
      
      if (!isCheckboxSelectionAllowed(row, setError, error)) {
        row.isSelectionAllowed = true;
      }

      setRevenueData(row.index, row.contractCode, row);

      setBorder("soldTicket", row.index, "highlight-field", false);
    }
    return isError
  }

